import React, { Fragment, useEffect } from "react";
import socket from "../../socket/socket";
import { useDispatch, useSelector } from "react-redux";
import { updateUserOnlineStatus } from "../../../services/action/common";

const UpdateUserStatus = () => {
  const { user } = useSelector((state) => state.authenticationReducer);
  const dispatch =useDispatch();
  useEffect(() => {
    if (user) {
      socket.on("internal_user_status", (userStatus) => {
        dispatch(updateUserOnlineStatus(userStatus))
      });

      return () => {
        socket.off("internal_user_status", () => {});
      };
    }
  }, [user]);



  return <Fragment></Fragment>;
};

export default UpdateUserStatus;
